<template>
    <div class="bidder-flow-page">
        <div class="page-header">
            <div class="page-header-content">
                <h2 class="page-title">{{ projectTitle }}</h2>
                <h2 class="page-title">投标人流程</h2>
            </div>
            <div class="header-action">
                <el-button type="primary" icon="el-icon-back" @click="handleBack">返回</el-button>
            </div>
        </div>

        <div class="main-workflow">
            <div class="workflow-stage main-stage">
                <div v-for="(stage, index) in mainTitles" :key="`main-${index}`" class="workflow-item">
                    <img :src="stage.leftImage" :alt="`${stage.name}`" class="decoration-image" />
                    <div class="content-wrapper">
                        <div class="content"
                            :style="{ backgroundColor: stage.colorClass != 'teal' ? '#11c2eb' : '#0ed7c6' }"
                            style="border-radius: 0px;   box-shadow: 0 2px 4px rgba(0, 0, 0, 0);">{{ stage.name }}</div>
                        <div class="content-overlay"></div>
                    </div>
                    <img :src="stage.rightImage" :alt="`${stage.name}`" class="decoration-image" />
                </div>
            </div>

            <!-- 第一阶段：报名与资料 -->
            <div class="workflow-stage">
                <div class="workflow-item" v-for="value in mainStages" :key="value.id" @click="handleStageClick(value)"
                    :style="{ visibility: !value.visibility ? 'visible' : 'hidden' }">
                    <img src="@/assets/image/bidProProcess-two-left.png" alt="" class="stage-decoration hidden" />
                    <div>
                        <div class="stage-icon-content">
                            <img :src="hoveredStage === value.name ? require('@/assets/image/bidProProcess-hover-after.png') : (value.colorClass == 'teal' ? require('@/assets/image/bidProProcess-tow-after.png') : require('@/assets/image/bidProProcess-one-after.png'))"
                                class="stage-icon" />
                        </div>
                        <div class="content" :class="{ 'pulse-animation': value.id === 103 && value.status === 0 }"
                            :style="{ backgroundColor: value.colorClass != 'teal' ? '#11c2eb' : '#0ed7c6' }"
                            @mouseenter="hoveredStage = value.name" @mouseleave="hoveredStage = null">
                            {{ value.id === 103 && value.status === 0 ? '未制作投标文件' : value.name }}
                        </div>
                    </div>
                    <img src="@/assets/image/bidProProcess-two-right.png" alt="" class="stage-decoration hidden" />
                </div>
            </div>

            <!-- 第二阶段：投标与开标 -->
            <div class="workflow-stage">
                <div class="workflow-item" v-for="value in secondaryStages" :key="value.id"
                    @click="handleStageClick(value)" :style="{ visibility: !value.visibility ? 'visible' : 'hidden' }">
                    <img src="@/assets/image/bidProProcess-two-left.png" alt="" class="stage-decoration hidden" />
                    <div>
                        <div class="stage-icon-content">
                            <img :src="hoveredStage === value.name ? require('@/assets/image/bidProProcess-hover-after.png') : (value.colorClass == 'teal' ? require('@/assets/image/bidProProcess-tow-after.png') : require('@/assets/image/bidProProcess-one-after.png'))"
                                class="stage-icon" />
                        </div>
                        <div class="content" :class="{ 'pulse-animation': value.id === 203 && value.status === 0 }"
                            :style="{ backgroundColor: value.colorClass != 'teal' ? '#11c2eb' : '#0ed7c6' }"
                            @mouseenter="hoveredStage = value.name" @mouseleave="hoveredStage = null">
                            {{ value.id === 203 && value.status === 0 ? '未缴纳技术服务费' : value.name }}
                        </div>
                    </div>
                    <img src="@/assets/image/bidProProcess-two-right.png" alt="" class="stage-decoration hidden" />
                </div>
            </div>

            <!-- 第三阶段：结果与我的 -->
            <div class="workflow-stage">
                <div class="workflow-item" v-for="value in resultStages" :key="value.id"
                    @click="handleStageClick(value)" :style="{ visibility: !value.visibility ? 'visible' : 'hidden' }">
                    <img src="@/assets/image/bidProProcess-two-left.png" alt="" class="stage-decoration hidden" />
                    <div>
                        <div class="stage-icon-content">
                            <img :src="hoveredStage === value.name ? require('@/assets/image/bidProProcess-hover-after.png') : (value.colorClass == 'teal' ? require('@/assets/image/bidProProcess-tow-after.png') : require('@/assets/image/bidProProcess-one-after.png'))"
                                class="stage-icon" />
                        </div>
                        <div class="content" :class="{ 'pulse-animation': value.id === 303 && value.status === 0 }"
                            :style="{ backgroundColor: value.colorClass != 'teal' ? '#11c2eb' : '#0ed7c6' }"
                            @mouseenter="hoveredStage = value.name" @mouseleave="hoveredStage = null">
                            {{ value.id === 303 && value.status === 0 ? '响应文件' : value.name }}
                        </div>
                    </div>
                    <img src="@/assets/image/bidProProcess-two-right.png" alt="" class="stage-decoration hidden" />
                </div>
            </div>
            <!-- 第三阶段1： -->
            <div class="workflow-stage">
                <div class="workflow-item" v-for="value in resultStages1" :key="value.id"
                    @click="handleStageClick(value)" :style="{ visibility: !value.visibility ? 'visible' : 'hidden' }">
                    <img src="@/assets/image/bidProProcess-two-left.png" alt="" class="stage-decoration hidden" />
                    <div>
                        <div class="stage-icon-content">
                            <img :src="hoveredStage === value.name ? require('@/assets/image/bidProProcess-hover-after.png') : (value.colorClass == 'teal' ? require('@/assets/image/bidProProcess-tow-after.png') : require('@/assets/image/bidProProcess-one-after.png'))"
                                class="stage-icon" />
                        </div>
                        <div class="content"
                            :style="{ backgroundColor: value.colorClass != 'teal' ? '#11c2eb' : '#0ed7c6' }"
                            @mouseenter="hoveredStage = value.name" @mouseleave="hoveredStage = null">{{ value.name }}
                        </div>
                    </div>
                    <img src="@/assets/image/bidProProcess-two-right.png" alt="" class="stage-decoration hidden" />
                </div>
            </div>

            <!-- 创建一条虚线 -->
            <div class="workflow-line">
                <div class="workflow-line-item">
                    <span class="workflow-line-text">附加流程</span>
                </div>
            </div>
            <!-- 第四阶段 -->
            <div class="workflow-stage additional">
                <div class="workflow-item" v-for="value in endStages4" :key="value.id" @click="handleStageClick(value)"
                    :style="{ visibility: !value.visibility ? 'visible' : 'hidden' }">
                    <img src="@/assets/image/bidProProcess-two-left.png" alt="" class="stage-decoration hidden" />
                    <div>
                        <div class="content"
                            :style="{ backgroundColor: value.colorClass != 'teal' ? '#11c2eb' : '#0ed7c6' }"
                            @mouseenter="hoveredStage = value.name" @mouseleave="hoveredStage = null">{{ value.name }}
                        </div>
                    </div>
                    <img src="@/assets/image/bidProProcess-two-right.png" alt="" class="stage-decoration hidden" />
                </div>
            </div>
            <!-- 第五阶段-->
            <div class="workflow-stage additional">
                <div class="workflow-item" v-for="value in endStages5" :key="value.id" @click="handleStageClick(value)"
                    :style="{ visibility: !value.visibility ? 'visible' : 'hidden' }">
                    <img src="@/assets/image/bidProProcess-two-left.png" alt="" class="stage-decoration hidden" />
                    <div>
                        <div class="content"
                            :style="{ backgroundColor: value.colorClass != 'teal' ? '#11c2eb' : '#0ed7c6' }"
                            @mouseenter="hoveredStage = value.name" @mouseleave="hoveredStage = null">{{ value.name }}
                        </div>
                    </div>
                    <img src="@/assets/image/bidProProcess-two-right.png" alt="" class="stage-decoration hidden" />
                </div>
            </div>
        </div>

        <!-- 聊天窗口组件 -->
        <ChatWindow :visible="chatWindowVisible" :position="chatWindowPosition" :current-user="currentUser"
            :chat-group-list="chatGroupList" :chat-messages="chatMessages" :default-group="chatGroupList[0] || {}"
            @close="handleChatWindowClose" @position-change="handleChatPositionChange" @send-message="handleSendMessage"
            @group-selected="handleGroupSelected" />
    </div>
</template>

<script>
import ChatWindow from '@/components/common/ChatWindow.vue'
import { getEvaluationRoomList, sendMessage, getChatList } from '@/api/chat/api'
import { evaluationEndQuery } from '@/api/evaluation/api'
import Cookies from 'js-cookie'
import { getUserInfo } from '@/api/user/api'
import { getBidderFlowTitle } from '@/utils/projectInfo.js'
import { getProjectInfo, getBidFlowStatus } from '@/api/bidEvaluationCommittee/api'
import MQTT from '@/utils/mqtt'
import { mqttUrl } from '@/utils/base.js'

export default {
    name: 'BidderFlow',
    components: {
        ChatWindow
    },
    data() {
        return {

            sectionCode: this.$route.query.sectionCode || '',
            hoveredStage: null,
            projectInfo: {
                projectCode: '',
                projectName: '',
            },
            projectTitle: '投标人流程——招标项目编号：　招标项目名称：',
            mainTitles: [
                {
                    id: 3,
                    name: '投标',
                    leftImage: require('@/assets/image/bidProProcess-one-left.png'),
                    rightImage: require('@/assets/image/bidProProcess-one-right.png'),
                    colorClass: 'blue'
                },
                {
                    id: 4,
                    name: '开标',
                    leftImage: require('@/assets/image/bidProProcess-two-left.png'),
                    rightImage: require('@/assets/image/bidProProcess-two-right.png'),
                    colorClass: 'teal'
                },
                {
                    id: 5,
                    name: '评标',
                    leftImage: require('@/assets/image/bidProProcess-one-left.png'),
                    rightImage: require('@/assets/image/bidProProcess-one-right.png'),
                    colorClass: 'blue'
                },
                {
                    id: 6,
                    name: '定标',
                    leftImage: require('@/assets/image/bidProProcess-two-left.png'),
                    rightImage: require('@/assets/image/bidProProcess-two-right.png'),
                    colorClass: 'teal'
                }
            ],
            // 第一阶段
            mainStages: [
                // { id: 103, name: '下载招标文件', colorClass: 'blue', visibility: false, route: '/bidderHome/downloadTender' },
                { id: 103, name: '制作投标文件', colorClass: 'blue', visibility: false, status: 1, route: '/bidderHome/makeBidDocument' },
                { id: 104, name: '开标大厅', colorClass: 'teal', visibility: false, route: '/openHall' },
                { id: 105, name: '解答评委疑问', colorClass: 'blue', visibility: false, route: '/bidderHome/answerJudges' },
                { id: 106, name: '查看中标候选人公示', colorClass: 'teal', visibility: false, route: '/bidderHome/viewWinBids' },
            ],
            // 第二阶段
            secondaryStages: [
                // { id: 203, name: '制作投标文件', colorClass: 'blue', visibility: false, route: '/bidderHome/makeBidDocument' },
                { id: 203, name: '缴纳技术服务费', colorClass: 'blue', visibility: false, status: 1, route: '/bidderHome/technologyFee' },
                { id: 204, name: '开标一览表', colorClass: 'teal', visibility: false, route: '/bidderHome/confirmBidRecord' },
                { id: 205, name: '', colorClass: 'blue', visibility: true, route: '' },
                { id: 206, name: '查看中标公告', colorClass: 'teal', visibility: false, route: '/bidderHome/checkNotice' },

            ],
            // 第三阶段
            resultStages: [
                { id: 303, name: '响应文件', colorClass: 'blue', visibility: false, status: 1, route: '/bidderHome/bidDocument' },
                { id: 304, name: '', colorClass: 'teal', visibility: true, route: '' },
                { id: 305, name: '', colorClass: 'blue', visibility: true, route: '' },
                { id: 306, name: '我的购标项目', colorClass: 'teal', visibility: true, route: '/bidderHome/myPurchaseProjects' }
            ],
            // 新增三阶段1
            resultStages1: [
                { id: 303, name: '响应文件', colorClass: 'blue', visibility: true, route: '/bidderHome/bidDocument' },
                { id: 304, name: '', colorClass: 'teal', visibility: true, route: '' },
                { id: 305, name: '', colorClass: 'blue', visibility: true, route: '' },
                { id: 306, name: '', colorClass: 'teal', visibility: true, route: '' }
            ],
            // 第四阶段
            endStages4: [
                { id: 403, name: '文件澄清与修改', colorClass: 'blue', visibility: false, route: '/bidderHome/bidClarification' },
                { id: 404, name: '', colorClass: 'teal', visibility: true, route: '' },
                { id: 405, name: '在线沟通', colorClass: 'blue', visibility: false, route: '' },
                { id: 406, name: '中标结果通知书', colorClass: 'teal', visibility: false, route: '/bidderHome/bidNoticeSuccessful' },
            ],
            // 第五阶段
            endStages5: [
                { id: 503, name: '文件质疑', colorClass: 'blue', visibility: false, route: '/bidderHome/raiseAQuestion' },
                { id: 504, name: '', colorClass: 'teal', visibility: true, route: '' },
                { id: 505, name: '二次报价', colorClass: 'blue', visibility: false, route: '/bidderHome/bidSecondQuotate' },
                { id: 506, name: '公示公告质疑', colorClass: 'teal', visibility: false, route: '/bidderHome/objectionManagement' },
            ],
            // 聊天相关数据
            chatWindowVisible: false,
            chatWindowPosition: { x: 100, y: 100 },
            currentUser: {
                name: '投标人:二公司',
                avatar: 'https://q3.itc.cn/q_70/images03/20250110/1e71eecf56b34344bcae6a5b85c0bec2.jpeg'
            },
            chatGroupList: [],
            chatMessages: [],
            selectedGroup: null,  // 当前选中的群组
            currentTopic: null    // 当前 MQTT 主题
        }
    },
    mounted() {
        if (this.sectionCode == '' || this.sectionCode == null) {
            this.sectionCode = localStorage.getItem('sectionCode')
        }
        this.getUserInfo()
        this.getProjectInfo()
        this.getBidFlowStatus()



    },
    methods: {
        handleBack() {
            this.$router.go(-1)
        },
        getBidFlowStatus() {
            getBidFlowStatus({ sectionCode: this.sectionCode }).then(res => {
                if (res.code == 200) {
                    const { bidStatus, payStatus, echoStatus } = res.data || {}

                    // bidStatus: 1-已制作, 0-未制作
                    // 在 mainStages 中找到"制作投标文件"并设置 status
                    const makeBidDocStage = this.mainStages.find(stage => stage.id === 103)
                    if (makeBidDocStage) {
                        makeBidDocStage.status = bidStatus
                    }

                    // payStatus: 1-已缴费, 0-未缴费
                    // 在 secondaryStages 中找到"缴纳技术服务费"并设置 status
                    const payFeeStage = this.secondaryStages.find(stage => stage.id === 203)
                    if (payFeeStage) {
                        payFeeStage.status = payStatus
                    }

                    // echoStatus: 1-已上传响应文件, 0-未上传响应文件
                    // 在 resultStages 中找到"响应文件"并设置 status
                    const echoFileStage = this.resultStages.find(stage => stage.id === 303)
                    if (echoFileStage) {
                        echoFileStage.status = echoStatus
                    }
                } else {
                    this.$message.error(res.msg || '查询评标状态失败')
                }
            }).catch(error => {
                console.error('查询投标流程状态失败:', error)
            })
        },

        // 点击阶段
        handleStageClick(stage) {
            if (stage.id == 405) {
                // 显示聊天窗口
                this.chatWindowVisible = true
                this.getEvaluationRoomList()
                return
            }
            console.log(stage);
            if (stage.id == 103 || stage.id == 203 || stage.id == 303 || stage.id == 403 || stage.id == 503) {
                // 获取评标是否结束
                this.evaluationEndQuery(stage)
                return
            }

            if (stage.route) {
                this.$router.push({ path: stage.route, query: { sectionCode: this.sectionCode, projectNumber: this.projectInfo.projectNumber, projectCode: this.projectInfo.projectCode } })
            }
        },
        // 查询状态 
        evaluationEndQuery(stage) {
            evaluationEndQuery(this.sectionCode).then(res => {
                if (res.code == 200) {
                    if (res.data != null) {
                        const evaluationStatus = res.data.evaluationStatus
                        if (evaluationStatus == 0) {
                            this.$router.push({ path: stage.route, query: { sectionCode: this.sectionCode, projectNumber: this.projectInfo.projectNumber, projectCode: this.projectInfo.projectCode } })
                        } else {
                            this.$message.error('评标已开始')
                            //   this.$router.push({ path: stage.route, query: { sectionCode: this.sectionCode, projectNumber: this.projectInfo.projectNumber, projectCode: this.projectInfo.projectCode } })
                        }
                    } else {
                        this.$router.push({ path: stage.route, query: { sectionCode: this.sectionCode, projectNumber: this.projectInfo.projectNumber, projectCode: this.projectInfo.projectCode } })
                    }


                } else {
                    this.$message.error(res.msg || '查询评标状态失败')
                }
            })
        },
        // 获取聊天室列表
        async getEvaluationRoomList() {
            const res = await getEvaluationRoomList({ sectionCode: this.sectionCode })
            if (res.code === 200 && res.data && res.data.length > 0) {
                this.chatGroupList = res.data.map(item => ({
                    id: item.groupId,
                    name: item.groupName,
                    memberCount: item.memberCount,
                    memberList: item.memberList,
                    headImg: 'https://img1.baidu.com/it/u=2347178170,458451905&fm=253&fmt=auto&app=138&f=JPEG?w=500&h=500'
                }))

                // 默认选择第一个群组
                this.selectedGroup = this.chatGroupList[0]
                this.currentTopic = this.selectedGroup.id

                // 初始化 MQTT 连接
                this.initMqtt(this.currentTopic)

                // 获取历史聊天记录
                this.getChatList()
            } else {
                this.chatGroupList = []
            }
        },
        // 获取项目信息
        async getProjectInfo() {
            this.projectTitle = await getBidderFlowTitle(this.sectionCode);

            const res = await getProjectInfo(this.sectionCode)
            this.projectInfo = res.data
        },

        // 处理聊天窗口位置变化
        handleChatPositionChange(newPosition) {
            this.chatWindowPosition = newPosition
        },

        // 初始化 MQTT
        initMqtt(topic) {
            // 断开之前的连接
            MQTT.disconnect()
            // 随机数生成客户端 ID
            const clientId = Math.floor(Math.random() * 1000000000000000000)
            MQTT.connect(mqttUrl, {
                username: '',
                password: '',
                clientId: clientId,
                keepalive: 60,
                clean: true
            })
            // 监听连接成功
            MQTT.on('connect', () => {
                console.log('MQTT 连接成功')
            })
            // 订阅主题
            MQTT.subscribe(topic, (message) => {
                const msg = JSON.parse(message)
                // 投标人页面：senderType==0（专家）在左边，senderType==1（投标人自己）在右边
                const formattedMsg = {
                    id: msg.msgId,
                    type: msg.senderType === 1 ? 'own' : 'other',
                    content: msg.content,
                    senderType: msg.senderType,
                    senderName: msg.senderName,
                    createdTime: msg.createdTime
                }

                this.getChatList()
            }, { qos: 2 })

            // 监听错误
            MQTT.on('error', (err) => {
                console.error('MQTT 连接失败:', err)
            })
        },

        // 获取历史聊天记录
        async getChatList() {
            if (!this.currentTopic) return
            const res = await getChatList(this.currentTopic)
            if (res.code === 200 && res.data) {
                // 投标人页面：senderType==0（专家）在左边，senderType==1（投标人自己）在右边
                this.chatMessages = res.data.map(msg => ({
                    id: msg.msgId,
                    type: msg.senderType === 1 ? 'own' : 'other',
                    content: msg.content,
                    senderType: msg.senderType,
                    senderName: msg.senderName,
                    createdTime: msg.createdTime
                }))
            }
        },

        // 处理发送消息
        async handleSendMessage(newMessage) {
            if (!newMessage.content || !newMessage.content.trim()) return

            try {
                const res = await sendMessage({
                    groupId: this.currentTopic,
                    msg: newMessage.content,
                    userName: Cookies.get('userName') || this.currentUser.name,
                    msgType: 1
                })
                if (res.code === 200) {
                    this.getChatList()
                } else {
                    this.$message.error(res.msg || '发送消息失败')
                }
            } catch (error) {
                console.error('发送消息失败:', error)
                this.$message.error('发送消息失败')
            }
        },

        // 处理群组选择
        handleGroupSelected(group) {
            if (this.selectedGroup && this.selectedGroup.id === group.id) return
            this.selectedGroup = group
            this.currentTopic = group.id
            this.chatMessages = []
            // 重新初始化 MQTT 连接
            this.initMqtt(this.currentTopic)
            // 获取新群组的历史消息
            this.getChatList()
        },

        // 关闭聊天窗口
        handleChatWindowClose() {
            this.chatWindowVisible = false
        },
        // 获取用户信息
        getUserInfo() {
            getUserInfo().then(res => {
                if (res.code === 200) {
                    Cookies.set('roleId', res.data.roleId)
                    this.$store.commit('changedRoleId', res.data.roleId)
                }
            })
        },
    },

    // 组件销毁前清理 MQTT 连接
    beforeDestroy() {
        MQTT.disconnect()
    }
}
</script>

<style lang="less" scoped>
@import '@/styles/minimal-gray-theme.less';

.bidder-flow-page {
    .apply-minimal-gray-theme();
}

// 页面头部
.page-header {
    display: flex;
    align-items: flex-start;
    justify-content: space-between;
    gap: 16px;
    margin-bottom: 20px;
}

.page-header-content {
    display: flex;
    flex-direction: column;
    text-align: start;
}

.header-action {
    text-align: end;
    flex-shrink: 0;
}

.page-title {
    color: @gray-700;
    margin: 0;
    font-size: 24px;
    font-weight: 600;
    line-height: 1.4;
}

// 主要流程区域
.main-workflow {
    display: flex;
    align-items: center;
    flex-direction: column;
    padding: 24px;
    background: #fff;
    border-radius: 8px;
    box-shadow: @shadow-sm;
    overflow-x: auto;
    margin-top: 20px;

    .workflow-stage {
        display: flex;
        align-items: center;
        justify-content: flex-start;
        flex-wrap: nowrap;
        gap: 16px;
        min-width: max-content;
        margin-top: 20px;

        &:first-child {
            margin-top: 0;
        }

        &.additional {
            margin-top: 16px;
        }

        .workflow-item {
            display: flex;
            align-items: center;
            height: 45px;
            flex-shrink: 0;
            cursor: pointer;
            transition: transform 0.2s ease;

            &:hover {
                transform: translateY(-2px);
            }

            .stage-decoration {
                height: 45px;
                width: auto;
                flex-shrink: 0;

                &.hidden {
                    visibility: hidden;
                }
            }

            .content-wrapper {
                position: relative;
                height: 45px;
                width: 200px;
                min-width: 180px;
                flex-shrink: 0;
            }

            .content {
                height: 45px;
                width: 200px;
                min-width: 180px;
                text-align: center;
                line-height: 45px;
                font-size: 14px;
                color: #fff;
                font-weight: 600;
                white-space: nowrap;
                overflow: hidden;
                text-overflow: ellipsis;
                border-radius: 25px;
                cursor: pointer;
                transition: all 0.3s ease;
                box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);

                &:hover {
                    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
                }
            }

            .pulse-animation {
                animation: pulse 2s ease-in-out infinite;
            }

            @keyframes pulse {

                0%,
                100% {
                    transform: scale(1);
                    box-shadow: 0 0 0 0 rgba(255, 77, 79, 0.4);
                }

                50% {
                    transform: scale(1.02);
                    box-shadow: 0 0 0 8px rgba(255, 77, 79, 0);
                }
            }

            .content-overlay {
                position: absolute;
                top: 0;
                left: 0;
                width: 100%;
                height: 100%;
                background-color: transparent;
                z-index: 10;
                pointer-events: auto;
            }

            .stage-icon-content {
                width: 100%;
                display: flex;
                align-items: center;
                margin-bottom: 5px;

                .stage-icon {
                    margin: auto;
                    width: 14px;
                    height: 9px;
                }
            }
        }
    }

    // 主阶段特殊样式
    .main-stage {
        margin-bottom: 8px;

        .workflow-item {
            .content {
                border-radius: 4px;
                font-size: 15px;
            }
        }

        .decoration-image {
            height: 45px;
            width: auto;
            flex-shrink: 0;
        }
    }

    // 虚线样式
    .workflow-line {
        margin-top: 40px;
        margin-bottom: 16px;
        display: flex;
        justify-content: center;
        align-items: center;
        width: 100%;
        position: relative;

        .workflow-line-item {
            width: 100%;
            height: 2px;
            background: repeating-linear-gradient(to right,
                    @gray-400 0px,
                    @gray-400 10px,
                    transparent 10px,
                    transparent 20px);
            border-radius: 1px;
            position: relative;
            display: flex;
            justify-content: center;
            align-items: center;

            .workflow-line-text {
                position: absolute;
                background-color: #fff;
                padding: 8px 20px;
                color: @gray-600;
                font-size: 14px;
                font-weight: 600;
                border-radius: 20px;
                white-space: nowrap;
                border: 1px solid @gray-200;
            }
        }
    }
}

@media (max-width: 768px) {
    .bidder-flow-page {
        padding: 16px;
    }

    .page-header {
        flex-direction: column;
        align-items: stretch;
    }

    .header-action {
        text-align: left;
    }

    .page-title {
        font-size: 20px;
    }

    .main-workflow {
        padding: 16px;

        .workflow-stage {
            gap: 12px;
        }
    }
}
</style>
